import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/grid.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import { requiredChildrenValidation } from '../../prop-types-validators/children-validator.js';
import GridContainer from './quarks/grid-container.js';
import { GRID_ALIGNMENTS, GRID_JUSTIFY, GRID_GUTTER_SIZES } from './types.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var Grid = function (_a) {
  var _b;
  var extraClasses = _a.extraClasses,
    children = _a.children,
    applyContainer = _a.applyContainer,
    align = _a.align,
    justify = _a.justify,
    gutterSize = _a.gutterSize;
  var bemGrid = HoneyBem.init('grid', styles);
  var bemGridClassNames = bemGrid.b((_b = {}, _b["align-".concat(align)] = align, _b["justify-".concat(justify)] = justify, _b["gutter-".concat(gutterSize)] = gutterSize, _b), extraClasses);
  var gridRow = /*#__PURE__*/React__default__default.createElement("div", {
    className: bemGridClassNames
  }, children);
  return applyContainer ? /*#__PURE__*/React__default__default.createElement(GridContainer, null, gridRow) : gridRow;
};
Grid.defaultProps = {
  extraClasses: null,
  applyContainer: false,
  align: null,
  justify: null,
  gutterSize: '2'
};
Grid.displayName = 'Grid';
Grid.propTypes = {
  extraClasses: PropTypes__default.string,
  children: requiredChildrenValidation('GridCol'),
  applyContainer: PropTypes__default.bool,
  align: PropTypes__default.oneOf(GRID_ALIGNMENTS),
  justify: PropTypes__default.oneOf(GRID_JUSTIFY),
  gutterSize: PropTypes__default.oneOf(GRID_GUTTER_SIZES)
};
var grid = Injecss(Grid, styles);

export { Grid, grid as default };
